import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex: 4;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.xLargeExtraBold};
  align-self: center;
  width: 100%;
  text-align: center;
  white-space: pre-line;
`;

const Message = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular};
  align-self: center;
  margin-top: ${({ theme }) => theme.spaces.space_4};
  line-height: ${({ theme }) => theme.spaces.space_18};
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spaces.space_12};
`;

function Texts({ title, message, customStyle }) {
  return (
    <Container>
      <Title>{title}</Title>
      <Message style={customStyle}>{message}</Message>
    </Container>
  );
}

Texts.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  customStyle: PropTypes.object,
};

export default Texts;
